import { QuestionAnswerRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";

export default function EmptyChat() {
    return (
        <Box
            sx={{
                display: "flex",
                flexGrow: 1,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                mt: 20,
                gap: 2,
            }}
        >
            <QuestionAnswerRounded sx={{ fontSize: 68 }} color="primary" />
            <Typography variant="h5">No haz seleccionado un chat</Typography>
        </Box>
    );
}
